import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useCallManager } from '../../../contexts/call_manager_context'
import {
  getActiveCallForCurrentMember,
  makeIsTopicActive,
} from '../../../reduxes/slices/calls/selectors'

export const PARTICIPATING = 'PARTICIPATING'
export const SPECTATING = 'SPECTATING'
export const ACTIVE = 'ACTIVE'
export const BLANK = 'BLANK'

type POVType = 'PARTICIPATING' | 'SPECTATING' | 'ACTIVE' | 'BLANK'

type ReturnType = {
  POV: POVType
}

export const useCallMetadataForTopic = (topicId: number): ReturnType => {
  const {
    activeCall: { callRecord, isOnCall },
  } = useCallManager()
  const isTopicActive = useMemo(makeIsTopicActive, [])
  // eslint-disable-next-line
  // @ts-ignore
  const isActive = useSelector((state) => isTopicActive(state, topicId))
  const activeCallForCurrentMember = useSelector(getActiveCallForCurrentMember)
  const isParticipating =
    isOnCall && callRecord && callRecord.topic_id === topicId
  const isSpectating =
    !isParticipating &&
    activeCallForCurrentMember &&
    activeCallForCurrentMember.topic_id === topicId

  const POV = useMemo(() => {
    if (isParticipating) {
      return PARTICIPATING
    } else if (isSpectating) {
      return SPECTATING
    } else if (isActive) {
      return ACTIVE
    } else {
      return BLANK
    }
  }, [isActive, isParticipating, isSpectating])

  return {
    POV,
  }
}
